// Hand-drawn SVG illustrations matching the Unite Recruitment Canva brand
// All paths use a single continuous mint-green line on transparent background.

export function InfinityLoop({ className = "", stroke = "#C2FFE1", strokeWidth = 6, animate = false }) {
  return (
    <svg
      viewBox="0 0 600 200"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <g className={animate ? "animate-draw-line" : ""}>
        <path d="M10,150 Q40,160 90,150 Q140,140 180,120 Q230,90 220,60 Q210,30 170,30 Q120,30 130,80 Q140,130 200,150 Q260,170 320,150 Q380,130 400,100 Q420,70 410,50 Q400,30 360,40 Q320,55 340,100 Q360,140 420,150 Q480,160 540,140 Q590,125 595,110" />
      </g>
    </svg>
  );
}

export function SmileFigure({ className = "", stroke = "#C2FFE1", strokeWidth = 5 }) {
  return (
    <svg
      viewBox="0 0 240 320"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* head */}
      <ellipse cx="125" cy="70" rx="55" ry="60" />
      {/* eyes */}
      <path d="M105 60 L108 70" />
      <path d="M148 60 L151 70" />
      {/* smile */}
      <path d="M95 85 Q125 110 158 85" />
      {/* body / neck */}
      <path d="M125 130 L125 230" />
      {/* arms */}
      <path d="M125 155 Q90 165 70 195 Q65 205 78 200 Q92 195 95 188" />
      <path d="M125 155 Q170 170 195 200 Q200 210 188 205 Q175 200 172 192" />
      {/* legs */}
      <path d="M125 230 L95 305 Q92 312 105 310 Q115 308 118 300" />
      <path d="M125 230 L160 300 Q165 310 153 310 Q142 308 140 300" />
    </svg>
  );
}

export function HouseHeart({ className = "", stroke = "#C2FFE1", strokeWidth = 5 }) {
  return (
    <svg
      viewBox="0 0 600 300"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* ground + heart + house all one stroke */}
      <path d="M30,260 Q90,255 120,255 Q160,255 180,245 Q170,230 150,205 Q130,180 145,165 Q165,148 185,165 Q205,182 195,205 Q185,225 180,245 L200,245 L200,140 L230,100 L240,140 L240,245 L290,245 L290,180 L325,180 L325,245 L355,245 L355,140 L370,108 L380,140 L380,245 Q450,250 510,248 Q560,246 590,240" />
      {/* door knob */}
      <circle cx="316" cy="215" r="3" />
    </svg>
  );
}

export function UnitedFigures({ className = "", stroke = "#C2FFE1", strokeWidth = 5 }) {
  // two figures facing each other, hands meeting in the middle
  return (
    <svg
      viewBox="0 0 460 320"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* figure 1 (left) */}
      <circle cx="90" cy="80" r="38" />
      <path d="M90,118 L90,210" />
      {/* arm reaching right */}
      <path d="M90,150 Q160,150 215,165" />
      <path d="M90,210 L70,290 Q68,300 80,298 Q92,296 95,288" />
      <path d="M90,210 L115,288 Q118,298 106,298 Q95,296 93,288" />

      {/* figure 2 (right) */}
      <circle cx="370" cy="80" r="38" />
      <path d="M370,118 L370,210" />
      <path d="M370,150 Q300,150 245,165" />
      <path d="M370,210 L390,290 Q392,300 380,298 Q368,296 365,288" />
      <path d="M370,210 L345,288 Q342,298 354,298 Q365,296 367,288" />

      {/* link / handshake glow line */}
      <path d="M215,165 Q230,175 245,165" strokeWidth={strokeWidth + 1} />
    </svg>
  );
}

export function WaveLine({ className = "", stroke = "#C2FFE1", strokeWidth = 5 }) {
  return (
    <svg
      viewBox="0 0 800 80"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M5,40 Q80,5 160,40 T320,40 T480,40 T640,40 T795,40" />
    </svg>
  );
}
